import * as React from "react"

import { cn } from "@/lib/utils"

interface MarqueeProps {
  children: React.ReactNode
  direction?: "left" | "right"
  pauseOnHover?: boolean
  reverse?: boolean
  fade?: boolean
  speed?: number
  className?: string
}

export function Marquee({
  children,
  direction = "left",
  pauseOnHover = false,
  reverse = false,
  fade = false,
  speed = 50,
  className,
}: MarqueeProps) {
  const [hovered, setHovered] = React.useState(false)

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={cn(
        "group flex gap-4 w-full overflow-hidden [--duration:40s] [--gap:1rem]",
        className
      )}
      style={
        {
          "--speed": `${speed}s`,
        } as React.CSSProperties
      }
    >
      <div
        className={cn(
          "flex w-max gap-[--gap] animate-marquee",
          reverse && "animate-marquee-reverse",
          hovered && pauseOnHover && "animation-paused"
        )}
        style={
          {
            animationDuration: `var(--speed)`,
          } as React.CSSProperties
        }
      >
        {children}
      </div>
      <div
        className={cn(
          "flex w-max gap-[--gap] animate-marquee",
          reverse && "animate-marquee-reverse",
          hovered && pauseOnHover && "animation-paused"
        )}
        aria-hidden="true"
        style={
          {
            animationDuration: `var(--speed)`,
          } as React.CSSProperties
        }
      >
        {children}
      </div>
    </div>
  )
}

interface MarqueeItemProps {
  children: React.ReactNode
  className?: string
}

function MarqueeItem({ children, className }: MarqueeItemProps) {
  return (
    <div className={cn("flex shrink-0 items-center", className)}>
      {children}
    </div>
  )
}

interface MarqueeFadeProps {
  side?: "left" | "right"
  className?: string
}

function MarqueeFade({ side = "left", className }: MarqueeFadeProps) {
  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-y-0 z-10 w-20 bg-gradient-to-r",
        side === "left" && "left-0 from-background to-transparent",
        side === "right" && "right-0 from-transparent to-background",
        className
      )}
    />
  )
}

interface MarqueeContentProps {
  children: React.ReactNode
  className?: string
}

function MarqueeContent({ children, className }: MarqueeContentProps) {
  return <div className={cn("flex w-max gap-4", className)}>{children}</div>
}

export { MarqueeItem, MarqueeFade, MarqueeContent }




